export const FAUX_BOLD_BLOCKLIST: ReadonlySet<string> = new Set([
  'Belluga Solid Alt',
])

export const FAUX_ITALIC_BLOCKLIST: ReadonlySet<string> = new Set([])

export const familyAllowsBold = (family: string | null | undefined): boolean =>
  !family || !FAUX_BOLD_BLOCKLIST.has(family)

export const familyAllowsItalic = (
  family: string | null | undefined,
): boolean => !family || !FAUX_ITALIC_BLOCKLIST.has(family)
